import apiEndpoints from '../../../api';
import { clean, url, listParams, bodyOf, getReq, writeReq } from './vmsHttp';

export const getGatePassesListReq = (action) => {
    const d = action.data;
    return getReq(apiEndpoints.SOCIETY_GET_GATE_PASSES_LIST_API, listParams(d, {
        status: d?.status,
        flat_id: d?.flatId,
        visitor_id: d?.visitorId,
        pass_type: d?.passType,
    }), 'Failed to load gate passes');
};

export const getGatePassDetailsReq = (action) =>
    getReq(url(apiEndpoints.SOCIETY_GET_GATE_PASS_DETAILS_API, { id: action.data.id }),
        undefined, 'Failed to load gate pass');

// Keyed on visitor_id, so the visitor must already exist — unlike a
// pre-approval, which matches on a raw phone number.
export const createGatePassReq = (action) =>
    writeReq('post', apiEndpoints.SOCIETY_CREATE_GATE_PASS_API, clean(bodyOf(action.data)),
        'Gate pass issued', 'Failed to issue gate pass');

// visitor_id, flat_id, wing_id and society_id are fixed at issue; status is
// changed through revoke, not here.
export const updateGatePassReq = (action) =>
    writeReq('put', url(apiEndpoints.SOCIETY_UPDATE_GATE_PASS_API, { id: action.data.id }),
        bodyOf(action.data, ['visitor_id', 'flat_id', 'wing_id', 'society_id', 'status']),
        'Gate pass updated', 'Failed to update gate pass');

// Soft delete leaves `status` untouched, so a deleted pass still reads ACTIVE
// if fetched directly — it simply stops matching at the gate.
export const deleteGatePassReq = (action) =>
    writeReq('delete', url(apiEndpoints.SOCIETY_DELETE_GATE_PASS_API, { id: action.data.id }),
        undefined, 'Gate pass deleted', 'Failed to delete gate pass');

export const revokeGatePassReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_REVOKE_GATE_PASS_API, { id: action.data.id }),
        clean(bodyOf(action.data)), 'Gate pass revoked', 'Failed to revoke gate pass');
